import momentTZ from "moment-timezone";

/**
 * Normalize datetime string input from upstream systems (PMS UTC `.000Z`,
 * Coreplus space-before-offset, etc.).
 */
export const normalizeDateTimeInput = (value) => {
  if (typeof value !== "string") {
    return value;
  }
  return value.replace(/\s+/g, "");
};

/**
 * Parse a stored appointment timestamp and return local time-of-day (HH:mm)
 * in the given timezone, or null when missing / unparseable.
 */
export const toLocalTimeOfDay = (dateTimeStr, timezone) => {
  if (!dateTimeStr) {
    return null;
  }
  const parsed = momentTZ(normalizeDateTimeInput(dateTimeStr));
  return parsed.isValid() ? parsed.tz(timezone).format("HH:mm") : null;
};

/**
 * Parse a stored appointment timestamp and return local calendar date (YYYY-MM-DD)
 * in the given timezone, or null when missing / unparseable.
 */
export const toLocalDateInTimezone = (dateTimeStr, timezone) => {
  if (!dateTimeStr) {
    return null;
  }
  const parsed = momentTZ(normalizeDateTimeInput(dateTimeStr));
  return parsed.isValid() ? parsed.tz(timezone).format("YYYY-MM-DD") : null;
};
